export const environment = {
  name: "production",
  clientUrl: 'https://crm.atoz.lu/',
  apiUrl: 'https://crm.atoz.lu/api/',
  issuer: 'https://auth.atoz.lu/realms/atoz',
  matomoSiteId: 6,
  sentryDsn: "https://3311927c69a3516c3a99f7cc6275a041@o4506942806425600.ingest.us.sentry.io/4507746832809984",
  sentryTracePropagationTargetRegex: '^https:\/\/crm\\.atoz\\.lu\/api'
};
